import { GLOBAL_SIGN_OUT } from '../constants/metrics';
import { request } from '../utils/apiHelper';
import { v4 as uuidv4 } from 'uuid';

/**
 * The called API will sign the user out by revoking all auth/refresh tokens for that user.
 *
 * @param apiPath Path to the globalSignOut API.
 */
export async function globalSignOut(
  apiPath: string
): Promise<Response | undefined> {
  const response = await request(
    apiPath,
    {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        'X-Correlation-ID': uuidv4(),
      },
    },
    { metricNs: GLOBAL_SIGN_OUT, treat404AsOk: true }
  );
  if (response.ok === false) return;
  const result = await response.json();
  return result;
}

export default globalSignOut;
